import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@valorizasm.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate("/");
  };

  return (
    <div className="min-h-screen w-full flex bg-noc-bg">
      <div
        className="hidden lg:flex lg:w-1/2 relative items-end p-12"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(11,14,13,0.2) 0%, rgba(11,14,13,0.95) 100%), url(https://images.unsplash.com/photo-1508939546992-1252a12b4299?crop=entropy&cs=srgb&fm=jpg&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="relative z-10 text-white max-w-md">
          <p className="text-[11px] uppercase tracking-[0.3em] text-valoriza-leaf font-bold mb-3">Valoriza Servicios Medioambientales</p>
          <h2 className="text-3xl font-black tracking-tighter leading-tight">
            Vigilancia IRIS y control de calidad — Zona Nord de Barcelona
          </h2>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            Detecta y corrige antes de que la queja llegue al Ajuntament.
          </p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm animate-fade-up">
          <img
            src="https://valorizasm.com/templates/valoriza/images/logos/VALORIZA_color_negativo.svg"
            alt="Valoriza"
            className="h-8 mb-8 invert dark:invert-0"
          />
          <p className="text-[11px] uppercase tracking-[0.25em] text-valoriza-leaf font-bold mb-1">SENTINEL BCN</p>
          <h1 className="text-3xl font-black tracking-tighter mb-8">Calidad e Incidencias</h1>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email">Correo corporativo</Label>
              <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11" />
            </div>
            {error && (
              <p className="text-sm text-accent-alert font-medium" data-testid="login-error-message">
                {error}
              </p>
            )}
            <Button type="submit" data-testid="login-submit-button" disabled={loading} className="w-full h-11 bg-valoriza-leaf text-black font-bold hover:bg-valoriza-leaf/90">
              {loading ? "Accediendo..." : "Acceder"}
            </Button>
          </form>
          <p className="mt-8 text-xs text-muted-foreground leading-relaxed">
            Usuarios DEMO (contraseña: Valoriza2026!): admin@valorizasm.com · jefe.servicio@valorizasm.com · encargado.n1@valorizasm.com · oficina@valorizasm.com · lectura@valorizasm.com
          </p>
        </div>
      </div>
    </div>
  );
}
